module.exports = __webpack_public_path__ + "img/balkongelaender03.3cfa2916.webp";